module.exports = __webpack_public_path__ + "img/reset.c7ec9372.svg";